export class NationalityModel {
  public nationalityCode: string;
  public nationalityDescription: string;
  public status: string;
  public user: string;
  public url: string;

  constructor(nationalityCode: string, nationalityDescription: string, status: string, user: string, url: string) {
    this.nationalityCode = nationalityCode;
    this.nationalityDescription = nationalityDescription;
    this.status = status;
    this.user = user;
    this.url = url;
  }
}
